import { useCallback } from 'react'
import { useMutation } from 'react-query'
import messageDeleteService from '../../services/api/message-delete'
import useToasts from '../use-toasts'
import useConfirmationDialog from '../use-confirmation-dialog'
import useMessagesCache from '../use-messages-cache'

//  Hook will display a confirmation dialog and then delete once confirmed.
const useMessageDeletion = ({
    onDeleted = () => {},
    messageId
} = {}) => {
    const { clear: clearCache } = useMessagesCache()
    
    const { success: toastSuccess, error: toastError } = useToasts()



    //  Setup what should happen when the message is deleted
    const onSuccess = useCallback(() => {
        toastSuccess('Message deleted!')
        clearCache()
        onDeleted()
    }, [toastSuccess, onDeleted, clearCache])

    //  What should happen if message deletion errors
    const onError = useCallback(() => {
        toastError('There was a problem deleting message.')
    }, [toastError])

    const [ deleteMutation ] = useMutation(messageDeleteService, { onSuccess, onError })

    //  What happens when the user confirms message to be deleted
    const onDeleteConfirmed = useCallback(() => {
        console.log('Deleting:', messageId )
        deleteMutation({ id: messageId })
    }, [deleteMutation, messageId])

    const { showConfirmation } = useConfirmationDialog({
        description: 'You cannot retrieve this message once its deleted',
        onConfirm: onDeleteConfirmed
    })

    return {
        deleteMessage: showConfirmation
    }
}

export default useMessageDeletion